import { select, withQuery } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { Link } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: 20px;
  flex-direction: column;
  white-space: normal;
  max-width: 950px;
  width: 100%;
  border-radius: 12px;
  ${withQuery.lg.down()} {
    width: 950px;
    margin: 0px 0px 20%;
    padding: 0px;
  }
  ${withQuery.md.down()} {
    width: 100%;
    max-width: 950px;
    margin: ${({ moduleId }) => (moduleId === 'step4Module2Form' ? '24px 0px 10%' : '45px 0px 10%')};
    margin-bottom: 0;
  }
  ${withQuery.xxs.down()} {
    padding: ${({ moduleId }) => (moduleId === 'step4Module2Form' ? '0 16px' : '0px')};
  }
  > div {
    position: relative;
  }
`;

export const WrapperContent = styled.div`
  input,
  select,
  textarea {
    font-family: 'Hind';
    font-weight: 400;
    font-size: 14px;
  }
  box-shadow: -1px 2px 20px 0 rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  width: 100%;
  white-space: normal;
  ${withQuery.lg.down()} {
    margin: 0px;
    width: auto;
  }
  ${withQuery.md.down()} {
    box-shadow: none;
  }
  ${withQuery.sm.down()} {
    padding-bottom: 64px;
  }
`;

const commonBtns = css`
  -webkit-appearance: none;
  outline: none;
  margin-right: 24px;
  height: 48px;
  border-radius: 12px;
  padding: 0px 24px;
  color: #fff;
  text-shadow: 0 0 0.6px #fff, 0 0 0.6px #fff, 0 0 0.6px #fff;
  :hover {
    cursor: pointer;
  }
  :disabled {
    opacity: 0.4;
    cursor: wait;
  }
  ${withQuery.xs.down()} {
    margin: 0;
    width: 100%;
    max-width: 146px;
  }
`;

export const Submit = styled.input`
  ${commonBtns};
  background-color: ${getColor('primary')};
  display: ${props => props.hide && 'none'};
  min-width: 110px;
  &.saveAndExit {
    color: black;
    background-color: white;
    border: 1px solid ${getColor('primary')};
    font-weight: 600;
    font-family: 'Hind';
    font-size: 1.4rem;
    margin-right: 10px;
  }
`;

export const StyledLink = styled(Link)`
  ${commonBtns};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-color: ${getColor('primary')};
  position: inherit;
  ${withQuery.xs.down()} {
    margin: 0;
    width: unset;
    max-width: unset;
  }
`;

export const BackButton = styled.button`
  ${commonBtns};
  color: black;
  font-weight: 600;
  font-family: 'Hind';
  font-size: 1.4rem;
  background-color: transparent;
  display: flex;
  align-items: center;
  > svg {
    margin-top: 12px;
    margin-right: -5px;
  }
`;

export const ButtonsRow = styled.div`
  height: 88px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: ${({ isPaymentError, isPaymentSuccess }) =>
    isPaymentError || isPaymentSuccess ? 'flex-end' : 'space-between'};
  background-color: ${select('lightGray')};
  padding: 16px;
  &.step1 {
    justify-content: flex-end;
    > div {
      width: 100%;
      justify-content: flex-end;
    }
  }
  > div.submitContainer {
    display: flex;
    flex-direction: row;
    ${props => props.saveExit && 'justify-content: flex-end'};
  }
  ${withQuery.md.down()} {
    &.only,
    &.step1 {
      justify-content: flex-end;
      > div {
        justify-content: space-between;
      }
    }
    > input {
      max-width: 146px;
    }
    > div.submitContainer {
      width: 100%;
      justify-content: space-between;
      ${props => !props.saveExit && 'justify-content: flex-end'};
    }
  }
  ${withQuery.sm.down()} {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 3;
    height: 64px;
  }
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 31px;
  display: block;
  margin: 0px 0px 30px;
  white-space: break-spaces;
  ${withQuery.lg.down()} {
    font-size: 20px;
    padding: 0px 0px 20px;
    margin: 0px;
  }
  ${withQuery.lg.down()} {
    display: ${({ moduleId }) => (moduleId === 'step4Module2Form' ? 'none' : 'unset')};
    padding: 0px 10px;
  }
  ${withQuery.xs.down()} {
    padding: 0px 16px;
    white-space: inherit;
  }
  ${withQuery.xxs.down()} {
    padding: 0px 20px 20px;
  }
`;

const dotFlashing = keyframes`
  0% {
    opacity: 1;
  }
  50%{
    opacity: 0.4;
  }
  100% {
    opacity: 0.2;
  }
`;

export const LoadingContainer = styled.div`
  ${commonBtns};
  background-color: ${getColor('primary')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  &.saveAndExit {
    background-color: white;
    border: 1px solid ${getColor('primary')};
    margin-right: 10px;
    ${withQuery.sm.up()} {
      min-width: 140px;
    }
  }
`;

export const Loading = styled.div`
  &.dot-flashing {
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
    color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
    animation: ${dotFlashing} 1.5s infinite linear normal;
    animation-delay: 0.1s;
    ::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
    }
    ::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
    }
    ::before {
      left: -15px;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
      color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
      animation: ${dotFlashing} 1.5s infinite normal;
    }
    ::after {
      left: 15px;
      width: 8px;
      height: 8px;
      border-radius: 4px;
      background-color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
      color: ${props => getColor(props.saveAndExit ? 'primary' : 'white')};
      animation: ${dotFlashing} 1.5s infinite normal;
      animation-delay: 0.5s;
    }
  }
`;
